"use strict";
/**
 * Application Data Transfer Objects (DTOs).
 */
Object.defineProperty(exports, "__esModule", { value: true });
